const GARAGE_HOME_MODAL = 'garage-home-modal';
const GARAGE_DASHBOARD_MODAL = 'garage-dashboard-modal';
const ADD_VEHICLE_FLOW = 'ADD_VEHICLE_FLOW';
const PLATE_FORM = 'PLATE_FORM';
const VEHICLE_INFORMATION_FORM = 'VEHICLE_INFORMATION_FORM';
const DELETE_PLATE_FORM = 'DELETE_PLATE_FORM';
const UPDATE_PHOTO_FORM = 'UPDATE_PHOTO_FORM';
const MISSING_VEHICLE_INFORMATION = 'MISSING_VEHICLE_INFORMATION';
const LOGIN_FORM = 'LOGIN_FORM';
const REGISTRATION_FORM = 'REGISTRATION_FORM';
const LOGIN_REGISTRATION_WRAPPER = 'LOGIN_REGISTRATION_WRAPPER';
const FORGOT_PASSWORD_FORM = 'FORGOT_PASSWORD_FORM';
const INSERT_PLATE_SUCCESS = 'INSERT_PLATE_SUCCESS';
const UPDATE_VEHICLE_SUCCESS = 'UPDATE_VEHICLE_SUCCESS';
const MESSAGE = 'MESSAGE';
const CREATE = 'CREATE';
const UPDATE = 'UPDATE';

// Events listing
const EVENT_GARAGE_AUTHENTICATION_STATUS_CHANGE = 'garage:authentication:change-status';
const EVENT_GARAGE_AUTHENTICATION_LOGIN = 'garage:authentication:login';
const EVENT_GARAGE_AUTHENTICATION_LOGOUT = 'garage:authentication:logout';
const EVENT_USER_PROFILE_UPDATE = 'user:profile:update';

export const getApiRootUrl = () => {
    if (!window.location.origin) {
        window.location.origin = `${window.location.protocol}//${window.location.hostname}`;
    }

    return window.location.origin;
};

export const getApiUrl = () => `${getApiRootUrl()}/wp-json`;
export const getDictionary = () => (window.drivek_v4 ? window.drivek_v4.dictionary : {});
export const appName = 'DriveK';

export const config = {
    API_URL: getApiUrl(),
    DEFAULT_LANG: 'it',
    GOOGLE_MAP_API_KEY: 'AIzaSyBDwlAatloMvVzz8qvCkmaIHVhqAhAR6Ec',
    componentsName: {
        GARAGE_HOME_MODAL,
        GARAGE_DASHBOARD_MODAL,
        LOGIN_REGISTRATION_WRAPPER,
        LOGIN_FORM,
        REGISTRATION_FORM,
        FORGOT_PASSWORD_FORM,
        ADD_VEHICLE_FLOW,
        PLATE_FORM,
        VEHICLE_INFORMATION_FORM,
        DELETE_PLATE_FORM,
        UPDATE_PHOTO_FORM,
        MISSING_VEHICLE_INFORMATION,
        MESSAGE,
        INSERT_PLATE_SUCCESS,
        UPDATE_VEHICLE_SUCCESS,
    },
    vehicleInformationSteps: {
        CREATE,
        UPDATE,
    },
    images: {
        'generic-error': '/wp-content/themes/drivek/v4/assets/svg/illustrations/generic-error.svg',
        'generic-email-confirmed': '/wp-content/themes/drivek/v4/assets/svg/illustrations/generic-email-confirmed.svg',
        'car-insert-plate-added': '/wp-content/themes/drivek/v4/assets/svg/illustrations/car-insert-plate-added.svg',
        'empty-calendar': '/wp-content/themes/drivek/v4/assets/svg/illustrations/empty-calendar.svg',
        'empty-garage': '/wp-content/themes/drivek/v4/assets/svg/illustrations/empty-garage.svg',
        'generic-vehicle': '/wp-content/themes/drivek/v4/assets/svg/illustrations/generic-vehicle.svg',
        'generic-vehicle-club': '/wp-content/themes/drivek/v4/assets/svg/illustrations/generic-vehicle-club.svg',
        calendar: '/wp-content/themes/drivek/v4/assets/shift/svg/illustrations/calendar.svg',
    },
    plates: {
        en: { regex: '([a-zA-Z]{1}[0-9]{4}[a-zA-Z]{3})|([a-zA-Z]{2}[0-9]{2}[a-zA-Z]{3})', plh: 'AA12AAA' },
        it: { regex: '[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}', plh: 'AA123AA' },
        es: { regex: '([a-zA-Z]{2}[0-9]{4}[a-zA-Z]{2})|([0-9]{4}[a-zA-Z]{3})', plh: 'AA1234AA' },
        fr: { regex: '([a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2})|([0-9]{4}[a-zA-Z]{2}[0-9]{2})', plh: 'AA123AA' },
        de: { regex: '[a-zA-Z0-9]{17}', plh: '1234567890ABCDEFG' },
    },
    events: {
        EVENT_GARAGE_AUTHENTICATION_STATUS_CHANGE,
        EVENT_GARAGE_AUTHENTICATION_LOGIN,
        EVENT_GARAGE_AUTHENTICATION_LOGOUT,
        EVENT_USER_PROFILE_UPDATE,
    },
    dictionary: getDictionary(),
};

export const versionConfigurationConflict = {
    ADD_ALL: 'ADD_ALL',
    ADD_ONE_OF: 'ADD_ONE_OF',
    ADD_ONE_ALL: 'ADD_ONE_ALL',
    REMOVE_ALL: 'REMOVE_ALL',
    REMOVE_ONE_OF: 'REMOVE_ONE_OF',
};

export const swiperConfig4Slides = {
    spaceBetween: 25,
    slidesPerView: 1,
    breakpointsInverse: true,
    breakpoints: {
        767: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    },
    watchOverflow: true,
};
